import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { SecurityService } from '../services/security.service';

@Injectable({
  providedIn: 'root',
})
export class DeliveryAuthGuard implements CanActivate {
  constructor(private securityService: SecurityService, private router: Router) {}

  canActivate(): boolean | UrlTree {
    this.securityService.restoreSession();

    if (this.securityService.isAuthenticated()) {
      return true;
    }

    return this.router.parseUrl('/login');
  }
}
